export const changeFavicon = (mainColor?: string) => {
  const updatedFavicon = (svgContent: string) => {
    const modifiedSvgContent = svgContent.replace(
      /fill="[^"]*"/g,
      `fill="${mainColor}"`,
    );

    const svgInBase64 = btoa(modifiedSvgContent);

    const link = document.querySelector<HTMLLinkElement>("link[rel*='icon']");
    if (link) {
      link.href = `data:image/svg+xml;base64,${svgInBase64}`;
    }
  };

  fetch('/favicon.svg')
    .then(response => response.text())
    .then(svgContent => {
      updatedFavicon(svgContent);
    });
};
